import React, { useState } from 'react';
import './Programs.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBriefcase, 
  faGraduationCap, 
  faHandHoldingUsd, 
  faBullhorn,
  faLayerGroup
} from '@fortawesome/free-solid-svg-icons';
import Modal from './Modal';
import ContactForm from './ContactForm';

const Programs = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const programs = [
    {
      title: "Economic Empowerment & Employment Creation",
      description: "Supporting women to establish and grow sustainable enterprises that create income and jobs within their communities.",
      icon: faBriefcase,
      impact: "Creating sustainable livelihoods"
    },
    {
      title: "Training & Business Development Support",
      description: "Entrepreneurship training, mentorship, and incubation focused on long-term viability and growth.",
      icon: faGraduationCap,
      impact: "Building business skills"
    },
    {
      title: "Funding & Resource Mobilization",
      description: "Strengthening access to startup capital, investment readiness, and diversified funding pathways for women-led initiatives.",
      icon: faHandHoldingUsd,
      impact: "Enabling financial access"
    },
    {
      title: "Advocacy & Policy Engagement",
      description: "Advancing gender-inclusive economic policies and legal protections that enable women's economic participation.",
      icon: faBullhorn,
      impact: "Shaping inclusive policies"
    },
    {
      title: "Cross-Cutting Focus Areas",
      description: "Across all our programs and partnerships, PEI integrates priority areas recognizing that economic injustice is deeply intertwined with safety, health, and wellbeing.",
      icon: faLayerGroup,
      impact: "Holistic empowerment approach"
    }
  ];

  return (
    <div className="programs-page">
      <section className="programs-hero">
        <div className="hero-content">
          <h1>Our Empowerment Programs</h1>
          <p>Transforming lives through targeted initiatives that address the unique challenges wome face in achieving equality.</p>
        </div>
      </section>

      <section className="programs-intro">
        <div className="container">
          <h2>Creating Pathways to Equality</h2>
          <p>At Parity Empowerment Initiative, we design comprehensive programs that tackle gender inequality from multiple angles. Our initiatives are carefully crafted to provide education, skills, mentorship, and advocacy opportunities that empower women and girls to reach their full potential.</p>
        </div>
      </section>

      <section className="programs-grid">
        <div className="container">
          <div className="programs-container">
            {programs.map((program, index) => (
              <div className="program-card" key={index}>
                <div className="program-icon">
                  <FontAwesomeIcon icon={program.icon} />
                </div>
                <h3>{program.title}</h3>
                <p>{program.description}</p>
                <div className="program-impact">
                  <span>Impact:</span> {program.impact}
                </div>
                <button className="learn-more-btn">Learn More</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="programs-cta">
        <div className="container">
          <h2>Ready to Make a Difference?</h2>
          <p>Whether you want to join our programs, volunteer, or support our work, we welcome your participation in creating a more equitable world.</p>
          <div className="cta-buttons">
            <button 
              className="primary-btn"
              onClick={() => setIsModalOpen(true)}
            >
              Get Involved
            </button>
            <button className="secondary-btn">Donate Now</button>
          </div>
        </div>
      </section>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <ContactForm 
          onClose={() => setIsModalOpen(false)}
          formType="Program Interest"
        />
      </Modal>
    </div>
  );
};

export default Programs;